import React, { useState, useEffect } from "react";

import { Modal, Button } from "react-bootstrap";

export default function JsonToForm(props) {
  const [show, setShow] = useState(props.show);

  const handleClose = () => props.handleClose();

  const extractMessage = (json) => { 
    
    if (json){
      
      try {
        const messageBody = document.getElementById('message-body');
        const messageObject = JSON.parse(json);  
        for (const chave in messageObject) {
          const label = document.createElement('label');
          label.textContent = `${chave}:`;
          const valor = document.createTextNode(` ${messageObject[chave]}`);
          messageBody.appendChild(label);
          messageBody.appendChild(valor);
          messageBody.appendChild(document.createElement('br'));
        }
      } catch (error) {
        console.log("Erro o extrair a mensagem");
        console.error(error);
      }    
      finally{
        document.getElementById("spinner").style.display = 'none';
      } 

    }
    
  };

  useEffect(() => {
    setShow(props.show);

    if (props.show){
      
      setTimeout(() => {
        document.getElementById("spinner").style.display = 'block';
        extractMessage(props.json);
      }, 300);
        
    }
    
  }, [props]);


  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Detalhes</Modal.Title>
        </Modal.Header>
        <Modal.Body id="message-body">
          <div id="spinner" className="spinner-border text-primary" role="status">
            <span className="sr-only"></span>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='primary'
            onClick={() => {
              handleClose();              
            }}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
